// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","fontNormal":"_2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","fontSmall":"_2tLKT1kaqUNKpr3hwnbdQw _2yWngtzq90F2CtpHEzi19P","defaultLineHeight":"1.4","colorBlackA40":"rgba(14, 19, 24, 0.4)","colorBlackA20":"rgba(14, 19, 24, 0.2)","colorWhite":"#fff","input":"VayzeLCHpH2qpk2vWXCeu _2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","textarea":"_3ZjYgC9qvb4GhKzYjlCwmN _2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","label":"GBQ2-7MbRMi0NHOX3GnXT _2tLKT1kaqUNKpr3hwnbdQw _2yWngtzq90F2CtpHEzi19P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/inputs/inputs.css
// module id = 904
// module chunks = 0